import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <span className="text-foreground-500 text-xs font-label tracking-wider uppercase">热门分类</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2 leading-tight">
            按分类吃瓜，<br />精准锁定你想看的料
          </h2>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-6 md:p-8 hover:bg-background-50 transition-all border border-background-200/70 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100/50 mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-foreground-800 text-lg`}></i>
              </div>
              <h3 className="font-label text-base font-semibold text-foreground-900 mb-2">
                {cat.name}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-foreground-500 text-xs">
                {cat.count > 0 ? `${cat.count} 篇最新爆料` : '敬请期待'}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}